import type {
  WalletOption,
  ExtensionWalletOption,
  WalletConnectOption,
  ExtensionWalletProvider,
  ExchangeOption,
} from '@stripe-internal/wallet-connect-wrapper';

export class WalletRegistry {
  private static walletOptions: WalletOption[] = [];

  private static exchangeOptions: ExchangeOption[] = [];

  static init(
    walletOptions: WalletOption[],
    exchangeOptions: ExchangeOption[],
  ): void {
    WalletRegistry.walletOptions = walletOptions;
    WalletRegistry.exchangeOptions = exchangeOptions;
  }

  static getAllWalletOptions(): WalletOption[] {
    return WalletRegistry.walletOptions;
  }

  static getAllExchangeOptions(): ExchangeOption[] {
    return WalletRegistry.exchangeOptions;
  }

  static getInstalledExtensionWallets(): ExtensionWalletOption[] {
    return WalletRegistry.walletOptions.filter(
      (option): option is ExtensionWalletOption =>
        option.provider !== 'WalletConnect' && option.isInstalledOnBrowser,
    );
  }

  static getWalletConnectWallets(): WalletConnectOption[] {
    return WalletRegistry.walletOptions.filter(
      (option): option is WalletConnectOption =>
        option.provider === 'WalletConnect',
    );
  }

  static getWalletOption(
    params:
      | {provider: ExtensionWalletProvider}
      | {provider: 'WalletConnect'; key: string},
  ): WalletOption | null {
    if (params.provider === 'WalletConnect') {
      // For WalletConnect, match by provider and key
      return (
        WalletRegistry.walletOptions.find(
          (option): option is WalletConnectOption =>
            option.provider === 'WalletConnect' && option.key === params.key,
        ) ?? null
      );
    }

    // For extension wallets, match by provider only
    return (
      WalletRegistry.walletOptions.find(
        (option): option is ExtensionWalletOption =>
          option.provider === params.provider,
      ) ?? null
    );
  }
}
